import {Component, OnInit, Inject } from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatTableDataSource} from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {PushService} from '../../../services/push.service';
import {Push} from '../../../models/push';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import {Member} from 'src/app/models/member';
import {MemberService} from 'src/app/services/member.service';
import {EventService} from 'src/app/services/event.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {PushMembersDialogComponent} from '../push-members-dialog/push-members-dialog.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-push-dialog',
  templateUrl: './push-dialog.component.html',
  styleUrls: [ './push-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
  ]
})
export class PushDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public pushForm: FormGroup;
  public current_push: Push;

  public isEdit: boolean;
  public spinner: boolean = false;
  public arrayEvents: any;
  public push_types: any[] = []

  public allMembers: any[] = []
  public allEvents: any[] = []

  public push_type_selected: any;
  public user_selected_id: any;
  public user_selected: any = {}

  public targetListDataSource: MatTableDataSource<any>

  public flag_todos: boolean = false;
  public flag_evento: boolean = false;
  public flag_lista: boolean = false;

  constructor (
    public db: AngularFirestore,
    private fb: FormBuilder,
    public _pushService: PushService,
    public _memberService: MemberService,
    public _eventService: EventService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: Push
  ) {

    this.push_types.push({name: "Todos com o app instalado", value: "geral"})
    this.push_types.push({name: "Inscritos em um evento", value: "evento"})
    this.push_types.push({name: "Uma lista de membros", value: "lista"})

    this.loadMembers();
    this._eventService.loadAllEvents();

    this.current_push = this.data;

  }

  public displayedListColumns: string[] = [ 'icon', 'name', 'delete' ];

  ngOnInit () {

    this.targetListDataSource = new MatTableDataSource(this.current_push.list)

    this._adapter.setLocale('pt');
    // check is is insert or update
    this.isEdit = this.data.id != "0"
    // create user form
    this.pushForm = this.createForm()
    // populate the form
    this.setFormValues(this.data, this.pushForm)
  }

  async insert () {

    if (this.pushForm.valid) {
      this.spinner = true;
      let push: Push = this.createPush(this.pushForm.value);
      // console.log("push ---------------------");
      // console.log(JSON.stringify(push))
      const event_id = push.event_id

      // alterar no APP 
      /*
      defaults.dart
      db
          .collection("sbccv_product_itens")
          .where("product_id", isEqualTo: docProd.data()["product_id"])
          .get()
          .then((colEventos) {
        colEventos.docs.forEach((docEvento) {
          print("docEvento.id -------------------------------------------");
          print(docEvento.id);
          _firebaseMessaging.subscribeToTopic('evento' + docEvento.id);
        });
      */

      // lá está registrando pelo id de sbccv_product_itens e não pelo evento
      // o correto é:  _firebaseMessaging.subscribeToTopic('evento' + docEvento.event_id);
      // e não:  _firebaseMessaging.subscribeToTopic('evento' + docEvento.id);
      // ajustando por aqui para não ter que  republicar o app
      // corrigir para a p´roxima publicação

      if (push.push_type == "evento") {
        const productItem: any = (await this._pushService.getProductItens(event_id));
        console.log(JSON.stringify(productItem));
        push.event_id = productItem[ 0 ].id;
        /*
        console.log("productItem --------------------")
        console.log(JSON.stringify(productItem));
        console.log("event_id: " + event_id);
        console.log("push.event_id: " + push.event_id);
        */
      } else {
         push.event_id = "";
      }

      // console.log("push: ---------------------------");
      // console.log(JSON.stringify(push));

      this._pushService.insert(push)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.pushForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar('Sucesso!', '', 'success');
        })
        .catch((error) => {
          console.log("insert push error: " + error)
          this.snackBar.openSnackBar(error.details.code, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });


    }

  }



  update () {

    let count: number = 0;

    if (this.pushForm.valid) {
      this.spinner = true;
      let push: Push = this.createPush(this.pushForm.value);

      if (push.push_type == "lista") {

        for (let item of push.list) {
          this.db.doc<Member>('sbccv_members/' + item.id)
            .get()
            .subscribe((result) => {

              item.token = result.data().zztoken
              // console.log("item: " + item.token)

              count++
              if (count >= push.list.length) {
                //  console.log("push: " + JSON.stringify(push))

                this._pushService.update(push)
                  .then((ret) => {
                    console.log('sucesso: ' + JSON.stringify(ret))
                  })
                  .catch(error => {
                    console.log("error" + error.code)
                  })
              }

            })
        }

      }

    }
  }


  createPush (data: any): Push {

    let push: any = {}
    push.id = data.id;
    push.title = data.title;
    push.text = data.text;
    push.url = data.url ? data.url : '';

    if (this.isEdit)
      push.date_create = data.date_create;
    else
      push.date_create = new Date();

    push.sent = data.sent ? data.sent : false;

    push.push_type = data.push_type
    push.event_id = data.event_id ? data.event_id : ""
    push.list = this.current_push.list

    let dd = new Date(data.date_to_send).getDate()
    let mm = new Date(data.date_to_send).getMonth()
    let yy = new Date(data.date_to_send).getFullYear()

    let parts = data.time_to_send.split(":")

    let hora = parts[ 0 ]
    let min = parts[ 1 ]

    push.date_to_send = new Date(
      Number(yy),
      Number(mm),
      Number(dd),
      Number(hora),
      Number(min)
    )

    push.time_to_send = data.time_to_send;

    // console.log("createpush: " + JSON.stringify(push))

    return push;
  }

  setFormValues (data, form) {

    form.controls.id.setValue(data.id);
    form.controls.title.setValue(data.title);
    form.controls.text.setValue(data.text);
    form.controls.url.setValue(data.url ? data.url : '');
    form.controls.push_type.setValue(data.push_type);
    form.controls.event_id.setValue(data.event_id);
    form.controls.sent.setValue(data.sent);

    if (data.date_create) {
      let dt: any = data.date_create
      form.controls.date_create.setValue(new Date(dt.seconds * 1000));
    }

    if (data.date_to_send) {
      let dt: any = data.date_to_send
      form.controls.date_to_send.setValue(new Date(dt.seconds * 1000))
    }

    form.controls.time_to_send.setValue(data.time_to_send);

    switch (data.push_type) {
      case "todos":
        this.flag_todos = true;
        break;
      case "evento":
        this.flag_evento = true;
        break;
      case "lista":
        this.flag_lista = true;
        break;
    }

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      title: new FormControl('', [ Validators.required ]),
      text: new FormControl('', [ Validators.required ]),
      url: new FormControl(''),
      date_create: new FormControl(''),
      date_to_send: new FormControl(''),
      time_to_send: new FormControl(''),
      push_type: new FormControl('', [ Validators.required ]),
      event_id: new FormControl(''),
      sent: new FormControl(''),

    });
    return form
  }

  loadMembers () {
    // this.sub = 
    this._memberService.select()
      .subscribe((result) => {

        this.allMembers = []

        result.forEach(item => {

          if (item.payload.doc.data().name.length > 0 &&
            item.payload.doc.data().zztoken) {

            let entity: any = {};

            entity.id = item.payload.doc.id;
            entity.name = item.payload.doc.data().name;
            entity.zztoken = item.payload.doc.data().zztoken;
            entity.selected = false;

            this.allMembers.push(entity)

          }

        });
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  on_push_type_changed (event) {
    this.push_type_selected = event
    console.log("this.push_type_selected: " + this.push_type_selected)

    switch (this.push_type_selected) {
      case "todos":
        this.flag_todos = true;
        this.flag_evento = false;
        this.flag_lista = false;
        break;
      case "evento":
        this.flag_todos = false;
        this.flag_evento = true;
        this.flag_lista = false;
        break;
      case "lista":
        this.flag_todos = false;
        this.flag_evento = false;
        this.flag_lista = true;
        break;
    }

  }

  select_user (event) {
    this.user_selected_id = event;
  }

  remove_to_list (element) {
    this.current_push.list = this.current_push.list.filter((e) => {
      return e.id != element.id
    })
    this.targetListDataSource = new MatTableDataSource(this.current_push.list)
  }

  openMembersDialog () {

    let dialogRef = this.dialog.open(PushMembersDialogComponent, {
      width: '400px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: this.allMembers
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const selectedMembres = response[ 1 ];

      if (action === "ok") {
        selectedMembres.forEach((item) => {

          if (item.selected) {
            this.current_push.list.push({
              'id': item.id,
              'name': item.name,
              'token': item.zztoken
            })

          }
        })

        this.targetListDataSource = new MatTableDataSource(this.current_push.list)

      }

    })

  }

}


